﻿import React from "react";
import StarRatings from "react-star-ratings";
import {useTypedSelector} from "../hooks/useTypeSelector";
import {i18n} from "../helpers/localisation-helpers";
import ProductEnergyRating from "./ProductEnergyRating";
interface ProductTitleProps {
    hasBuyNowLinks?: boolean;
    starRating?: number;
    productIsDemoable?: boolean;
    demoUrl: string;
    energyRating: string;
    ukEnergyRatingRegUrl?: string;
    euEnergyRatingRegUrl?: string;
    isWarranty: boolean;
    extWarrantyId?: number;
    showDealerLocatorUrl?: boolean;
    dealerLocatorUrl?: string;
}


const ProductTitle = (props:ProductTitleProps) => {
    const { productData} = useTypedSelector((state) => state.product);

    return (
        <>
            {props.isWarranty && 
            <div id="filter-warranty">
                <div className="banner">
                    <div className="diagsplitintronarrow">
                        <div className="centred">
                            <div className="left-bar"></div>
                            <div className="image"></div>
                            <div className="right-bar">
                                <div className="copy">
                                  <h1>{i18n("Resource.Warranty", productData.PageLocalisations)}</h1>
                                    <div>
                                            <a className="btn light" href="/service-and-support/warranty/extended">{i18n("Resource.registerextendedwarranty", productData.PageLocalisations)}</a>
                                            <a className="btn light" href="/support/warranty/activate"> {i18n("Resource.activatestandardwarranty", productData.PageLocalisations)}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div className="product-title">
    
                <div className="onepcssgrid-1300 onepcssblockgrid">
                    <div className="onerow">
                        <div className="col12 last container">
                            
                            <div className={`top-items ${props.isWarranty ? "warranty" : ""}`}>
                                <div className="name">
                                    <div className="pname">
                                    <h2>{productData && productData.ProductNameDisplay}{!productData && <span>Loading...</span>}</h2>
                                    </div>
                                </div>
                                <ProductEnergyRating
                                    energyRating={props.energyRating}
                                    ukEnergyRatingRegUrl={props.ukEnergyRatingRegUrl}
                                    euEnergyRatingRegUrl={props.euEnergyRatingRegUrl}
                                />
                                <div id="topbuttonarea">
                                    <div className="purchase">
                                        {productData && productData.SiteRegion.toUpperCase() == "EN-GB" &&
                                            <div className="msrp">
                                                {productData.MsrpGbpPrice != null && productData.MsrpGbpPrice > 0 &&
                                                    <div className="gb-price">MSRP £{productData.MsrpGbpPrice}</div>}
                                            </div>
                                        }
                                    </div>
                                    <div className="btnrow">
                                        {productData && props.hasBuyNowLinks && <div> <a href="#buynow" className="btn">{i18n("Resource.BuyNow", productData.PageLocalisations)}</a></div>}
                                        {productData && props.productIsDemoable && props.demoUrl !== undefined && <div><a href={props.demoUrl} className="btn">{i18n("Forms.bookademo", productData.PageLocalisations)}</a></div>}
                                        {productData && props.showDealerLocatorUrl && props.dealerLocatorUrl !== undefined && <div><a href={props.dealerLocatorUrl} className="btn">{i18n("Titles.DealerLocator", productData.PageLocalisations)}</a></div>}
                                        {productData && props.isWarranty && productData.ShowWarrantyUrl && productData.WarrantyUrl !== undefined && <div className="warranty"><a href={productData.WarrantyUrl} className="btn">{i18n("Resource.WarrantyRegister", productData.PageLocalisations)}</a></div>}
                                    </div>

                                </div>
                                {productData && !props.isWarranty && <div className="rating">
                                    {/*<a href="/reviews/ownerreviews/writereview">Write a review</a>*/}
                                    <a href="/reviews/ownerreviews/writereview">{i18n("Resource.OwnerReview_WriteReview", productData.PageLocalisations)}</a>
                                    {/*<StarRatings*/}
                                    {/*    rating={props.starRating}*/}
                                    {/*    starRatedColor="gold"*/}
                                    {/*    starDimension="20px"*/}
                                    {/*    starSpacing="2px"*/}
                                    {/*    numberOfStars={5}*/}
                                    {/*    name='rating'*/}
                                    {/*/>*/}
                                </div>}



                            </div>


                        </div>
                    </div>
                </div>
    
            </div>
        </>
    )
}

export default ProductTitle;